export const levelCheck = {
  title: 'Level Check',
  subtitle: 'Check your current language level',
  
  // Language Selection
  selectLanguage: 'Select Learning Language',
  selectLanguagePlaceholder: 'Choose a language',
  japanese: '日本語',
  korean: '한국어',
  english: 'English',
  
  // Email Input
  emailLabel: 'Email Address',
  emailPlaceholder: 'your.email@example.com',
  emailDescription: 'We will send your test results',
  
  // Buttons
  startTest: 'Start Test',
  nextQuestion: 'Next',
  previousQuestion: 'Previous',
  submitTest: 'Submit Test',
  
  // Test Progress
  question: 'Question',
  of: 'of',
  
  // Results
  resultsTitle: 'Test Results',
  yourLevel: 'Your Level',
  score: 'Score',
  passed: 'Passed',
  failed: 'Failed',
  passThreshold: 'Pass Threshold: 85% or higher',
  
  // Messages
  selectLanguageFirst: 'Please select a language',
  enterEmail: 'Please enter your email address',
  testSubmitted: 'Test submitted. We will send the results to your email.',
  errorSubmitting: 'An error occurred. Please try again.',

  // ── Full level-check page (level-check/page.tsx) ──
  // Validation / alerts
  enterName: 'Please enter your name',
  invalidEmail: 'Invalid email format',
  selectLearningLanguage: 'Please select the language you are learning',
  saveFailed: 'Failed to save results. Please try again.',

  // Language names (learning language display)
  langEnglish: 'English',
  langJapanese: 'Japanese',
  langKorean: 'Korean',

  // Intro screen
  pageTitle: 'Language Level Check',
  pageSubtitle: 'Please enter your information before starting the level check',
  namePlaceholder: 'Your Name',
  emailInputPlaceholder: 'Email Address',
  selectLearningLanguageLabel: 'Select the language you are learning',
  testStructure: 'Test Structure:',
  levelAJa: 'Level A: 12 questions (4 vocabulary + 8 ability)',
  levelAOther: 'Level A: 8-10 questions (beginner)',
  levelB1Ja: 'Level B1: 12 questions (4 vocabulary + 8 ability)',
  levelB1Other: 'Level B1: 8-10 questions (intermediate)',
  levelB2Ja: 'Level B2: 12 questions (4 vocabulary + 8 ability)',
  levelB2Other: 'Level B2: 8-10 questions (upper-intermediate)',
  levelCJa: 'Level C: 12 questions (4 vocabulary + 8 ability)',
  levelCOther: 'Level C: 8-10 questions (advanced)',
  scoringNote: 'Score 85% or higher at each level to advance to the next level',
  scoringNoteJa: 'Score 85% or higher at each level to advance to the next level. Japanese version: Vocabulary questions 20 points + Ability questions 80 points = Total 100 points',
  startCheck: 'Start Level Check',

  // Results screen
  testComplete: 'Test Complete!',
  learningLanguageLabel: 'Learning Language: ',
  yourLevelLabel: 'Your Level: ',
  levelValue: 'Level {{level}}',
  thankYouBody: 'Thank you for completing the level check, {{name}}! We will review your results and contact you at {{email}} with next steps.',
  returnHome: 'Return to Home',

  // Quiz screen
  levelAssessment: 'Language Level Assessment',
  questionProgress: 'Question {{current}} of {{total}}',
  previous: 'Previous',
  next: 'Next',
  submitting: 'Submitting...',
  submitLevel: 'Submit Level'
};
